import announcementApi from './announcementApi';

const createAnnouncement = async (announcementData: Record<string, unknown>) => {
  try {
    const { data } = await announcementApi({
      method: 'POST',
      url: '/',
      data: announcementData,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
    return data;
  } catch (error) {
    console.error('[createAnnouncement] Failed:', error);
    throw error;
  }
};

export default createAnnouncement;
